<template>
  <LayoutModalHeaderComponent :class="$style.root">
    <template #content>
      <h1 :class="$style.title">
        {{ page?.title }}
      </h1>

      <h2
        v-if="page?.secondaryTitle"
        :class="$style.secondaryTitle"
      >
        {{ page?.secondaryTitle }}
      </h2>

      <ul
        :class="$style.dateRanges"
      >
        <li
          v-for="dateTimeRange in page?.dateTimeRanges"
          :key="dateTimeRange?.id"
        >
          <CoreDateTimeRangeComponent
          :dateStart="dateTimeRange?.dateTimeStart"
          :dateEnd="dateTimeRange?.dateTimeEnd"
          />&nbsp;<CoreTimeLabelComponent
            :dateStart="dateTimeRange?.dateTimeStart"
            :dateEnd="dateTimeRange?.dateTimeEnd"
          />
        </li>
      </ul>
    </template>

    <template #information>
      <div
        v-if="tags?.length"
        :class="$style.tags"
      >
        <template v-for="(tag, index) in tags" :key="index"><span :class="$style.tag">{{ tag?.trim() }}</span>&nbsp;</template>
      </div>

      <div
        v-if="page?.linkTopPage?.id"
        :class="$style.linkTopPageContainer"
      >
        <SharedLinkComponent
          :link="page?.linkTopPage"
          :class="$style.linkTopPage"
        >
          {{ page?.linkTopPage?.label }}
        </SharedLinkComponent>
      </div>
    </template>

    <template #linkToClose>
      <i18nLink
        :to="{ name: 'events', query }"
      >
        <CoreButtonsCloseComponent />
      </i18nLink>
    </template>
  </LayoutModalHeaderComponent>
</template>

<script lang="ts" setup>
const props = defineProps<{
  page: object
}>()

const route = useRoute()
const query = computed(() => route?.query)

const tags = props?.page?.eventCategories?.data?.map(i => i?.attributes?.label)?.filter(Boolean)
</script>

<style module lang="scss">
.root {}

.title {
  composes: reset-heading from global;
  composes: font-size-x-large from global;
}

.secondaryTitle {
  composes: reset-heading from global;
  composes: font-size-medium from global;
}

.categories {
  composes: font-size-x-large from global;
}

.dateRanges {
  composes: reset-list from global;
  composes: font-size-small font-helvetica from global;

  columns: 2;

  @media (max-width: $breakpoint-s) {
    columns: 1;
  }
}

.tags {
  composes: font-size-small font-helvetica from global;

  margin-top: var(--lh);

  grid-column: 1 / -1;
}

.tag {
  composes: font-size-small font-helvetica label-inverted from global;
}

.linkTopPageContainer {
  margin-top: var(--lh);
  grid-column: 1 / -1;

  display: flex;
  justify-content: flex-end;
}

.linkTopPage {
  composes: font-helvetica font-size-small button from global;

  background-color: var(--color--primary);
  color: var(--color--background);

  border-color: var(--color--primary);
}

.linkTopPage:hover {
  background-color: var(--color--background);
  color: var(--color--primary);
}
</style>
